// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1_2BG","location":"Header_location__3sBN9"};